import styled, { css } from "styled-components";
import { lighten } from "polished";
import * as colors from "../../settings/colors";

const Input = styled.input`
  color: ${colors.TEXT};
  font-family: inherit;
  font-size: 14px;
  line-height: 18px;
  box-sizing: border-box;
  width: 100%;
  padding: 8px 9px;
  border: 1px solid ${colors.DIVIDER};
  border-radius: 3px;
  box-shadow: inset 0 1px 2px ${colors.FORM_INPUT_INSET_SHADOW};

  &:focus {
    outline: 0;
    border-color: ${colors.BLUE};
    box-shadow: inset 0 1px 0 ${colors.FORM_INPUT_INSET_SHADOW},
      0 0 0 3px ${colors.FORM_INPUT_FOCUS_RING};
  }

  &[disabled],
  &[readonly] {
    background: ${lighten(0.05, colors.DIVIDER)};
  }

  &::placeholder {
    color: ${colors.TEXT_TERTIARY};
  }

  ${({ size }) =>
    size === "large" &&
    css`
      font-size: 16px;
      line-height: 22px;
      padding: 7px 9px;
    `};

  ${({ hasError }) => hasError && css`border-color: ${colors.RED};`};
`;

export default Input;



// WEBPACK FOOTER //
// ./src/components/forms/Input.js